// Normalise user- or machine-assembled address text before sending it to
// Adressevaelger, which is materially stricter about input than DAWA was.
//
// Verified against the live API:
//   "Industrigrenen 15,2635 Ishoj"   -> 0 hits   (comma without a trailing space)
//   "Industrigrenen 15, 2635 Ishoj"  -> 1 hit
//
// Ported from @coignite/danish-addresses-kds-js (MIT, Coignite ApS), with the
// comma rule added. Keep in sync with app/services/adressevaelger/query.rb.

// CommonJS on purpose - see the note in utm32.js. Keep this file async-free.

const DOORS = "th|tv|mf";

function normalizeQuery(text) {
    let t = text == null ? "" : String(text);

    // "t.h." / "t h" -> "th", and the same for tv/mf
    t = t
        .replace(/\bt\.?\s*h\.?\b/gi, "th")
        .replace(/\bt\.?\s*v\.?\b/gi, "tv")
        .replace(/\bm\.?\s*f\.?\b/gi, "mf");

    t = t.replace(/,(?=\S)/g, ", ");

    // "Vej87" -> "Vej 87" (house letters like "2A" are digit+letter, untouched)
    t = t.replace(/(\p{L})(\d)/gu, "$1 $2");

    // "5th" / "st.th" -> "5 th" / "st th"
    t = t.replace(
        new RegExp(`\\b(\\d{1,3}|st|kl)\\.?\\s*(${DOORS})\\b`, "gi"),
        (_match, floor, door) => `${floor} ${door.toLowerCase()}`
    );

    t = t.replace(new RegExp(`\\b(${DOORS})\\b`, "gi"), (match) => match.toLowerCase());

    return t.replace(/\s+/g, " ").trim().replace(/[.,\s]+$/, "");
}

module.exports = { normalizeQuery };
